import { render, staticRenderFns } from "./CasaComponent.vue?vue&type=template&id=0ec1b61e&"
import script from "./CasaComponent.vue?vue&type=script&lang=js&"
export * from "./CasaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports